/**
 * Created by swandelow on 03/04/17.
 */
angular.module('CarsSaraBo').factory('HotjarService', [function() {

    var stockTriggers = {
        '461258': 'stock0_ES', // for DEV
        '461263': 'stock0_EN',
        '461261': 'stock0_PT',
        '224307': 'stock0_ES', // for IC, RC, BETA and PROD
        '239585': 'stock0_EN',
        '239582': 'stock0_PT'
    };

    return {

        triggerStockSurvey: function (cars) {
            if (!("hotjarId" in window)) {
                console.log("No hotjarId defined");
                return;
            }

            var values = _.values(cars);
            var isZero = _.some(values, function(value) {
                return value === 0 || value === '0';
            });
            if(isZero) {
                hj('trigger', stockTriggers[window.hotjarId]);
            }
        }
    }
}]);


//////////////////
// WEBPACK FOOTER
// ./public/app/models/hotjar_service.js
// module id = 851
// module chunks = 3